import BaseService from "services/BaseService";
import _ from "lodash";

class LoginServices extends BaseService {

    userLogin = async ({ email, pass }) => {
        var data = await this._api.post("master/login", { email, pass });
        return data;
    }


 


}
export default LoginServices;
